<!--人文美育-视频库管理-->
<template>
    <div class="studio_nav_content" >
        <!--五馆合一  -->
        <el-scrollbar class="page-mode" v-show="showMode==='page'">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="1" class="mb0">
                        <div class="by-left-head-container" @click="backReadMuseum">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="queryClassLibrary" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" class="mb0">
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.className" placeholder="请输入教程名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQueryClass" type="primary" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="book-container">
                <div class="book-item" v-for="item in libraryList">
                    <div class="book-one" @click="viewSubjectFusion(item)">
                        <div class="book-img">
                            <img alt="" class="img-100" :src="item.coverUrl">
                        </div>
                        <div class="book-title">
                            {{ item.className }}
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <!--学科融合详情-->
        <div class="detail-mode" v-if="showMode==='subjectFusion'">
            <boyaa-subject-fusion :class-id="this.classId" @change-mode="changeModel"/>
        </div>
    </div>
</template>

<script>
import { listClassLibrary } from "@/api/admin/classLibrary";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/public";
import BoyaaSubjectFusion from "@/components/newMuseum/read/boyaaSubjectFusion.vue";

export default {
    name: "boyaaChinese",
    components: {BoyaaSubjectFusion, },
    data() {
        return {
            showMode:'page',
            subjectFusionMode:'subjectFusion',
            museumCourseMode:'museumCourse',
            searchVideoMode:'searchVideo',
            serviceUrl,
            keyword:'',
            subjectList: [],
            periodList: [],
            gradeList: [],
            libraryList: [],
            queryParams: {
                className: '',
                periodKey: '1',
                gradeKey: '',
                subjectKey: '21',
            },
            classId:'',
            museumKey:'',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryDict();
        this.queryClassLibrary();
    },
    mounted(){},
    methods: {
        queryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data;
                    this.changePeriod();
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            // this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.queryClassLibrary()
        },
        changeGrade() {
            // this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.queryClassLibrary()
        },
        queryClassLibrary(){
            listClassLibrary(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.libraryList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        handleQueryClass(){
            this.queryClassLibrary();
        },
        handleQuery(){
            this.showMode = this.searchVideoMode;
            this.$emit('change-mode',this.showMode);
        },
        viewSubjectFusion(item){
            this.classId = item.classId;
            this.$emit('change-mode',this.showMode);
            this.showMode = this.subjectFusionMode
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
        backReadMuseum(){
            this.$emit('back-read-museum', "homePage");
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.by-left-head-container{
    cursor: pointer;
    padding-left: 10px;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.book-container{
    width: 100%;
    height: auto;
    padding: 20px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.book-item{
    width: 20%;
    height: 100%;
    padding: 0 20px 10px 20px;
    box-sizing: border-box;
}
.book-one{
    width: 100%;
    height: 100%;
    padding: 8px;
    border: 1.5px solid #f1f1f1;
}
.book-one:hover{
    border: 1.5px solid #ff7f2e!important;
    color: #ff7f2e!important;
    font-weight: bold;
}
.book-img{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.book-title{
    height: 44px;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding: 0 5px 5px 5px;
    cursor: pointer;
}
</style>